import { PathUtils } from "@adobe/aem-spa-page-model-manager";

const featureFlags: Record<string, boolean> = JSON.parse(
    PathUtils.getMetaPropertyValue('featureFlagsProvider') ||
        '{}',
);

export const isNewErrorMessagingFlagActive = featureFlags && featureFlags['DPM-13460'] === true;
